<template>
  <div class="vlog-filter">
    <button
      :class="[
        'vlog-filter__header',
        {
          'vlog-filter__header--open': isOpen,
        },
      ]"
      @click="toggleFilters"
    >
      <p class="vlog-filter__heading">
        {{ $t('common.reports.show_filters') }}
      </p>
      <img
        :class="[
          'vlog-filter__chevron',
          {
            'vlog-filter__chevron--open': isOpen,
          },
        ]"
        width="32"
        height="32"
        src="@/assets/icons/16-chevron-down-white.svg?url"
        alt=""
      />
    </button>
    <div v-if="isOpen" class="vlog-filter__content">
      <section class="vlog-filter__section">
        <p class="vlog-filter__subheading">
          {{ $t('common.vlogs.season') }}
        </p>
        <FormBaseCheckbox
          v-for="season in availableSeasons"
          :key="season"
          v-model="filtersDraft.selectedSeasons[season]"
          class="checkbox-group__consent"
          :label="`${season} ${$t('common.vlogs.season')}`"
        />
      </section>
      <div class="vlog-filter__buttons">
        <BaseButton
          :title="$t('common.reports.reset')"
          outlined
          @click="onClearFilters"
        >
          <template #text>
            {{ $t('common.reports.reset') }}
          </template>
        </BaseButton>
        <BaseButton :title="$t('common.reports.apply')" @click="applyFilters">
          <template #text>
            {{ $t('common.reports.apply') }}
          </template>
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const vlogsStore = useVlogsStore()

const { filters, availableSeasons, filtersDraft } = storeToRefs(vlogsStore)
const { clearFilters } = vlogsStore

const isOpen = ref(false)

const toggleFilters = () => {
  isOpen.value = !isOpen.value
}

const onClearFilters = () => {
  clearFilters()
}

const applyFilters = () => {
  filters.value.selectedSeasons = {
    ...unref(filtersDraft.value.selectedSeasons),
  }
}
</script>

<style lang="scss" scoped>
.vlog-filter {
  &__header {
    background-color: var(--cobalt-800);
    color: white;
    padding: 12px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-radius: 16px;

    &--open {
      border-radius: 16px 16px 0 0;
    }
  }

  &__heading {
    margin: 0;
    font-size: var(--font-size-paragraph-s);
    font-weight: var(--font-weight-paragraph-bold);
    line-height: 26px;
  }

  &__content {
    padding: 32px;
    background-color: white;
    border-radius: 0 0 16px 16px;
  }

  &__section {
    margin-bottom: 28px;
  }

  &__subheading {
    @include heading-subheading;
  }

  &__chevron {
    width: 16px;
    transition: transform 0.3s ease-in-out;

    &--open {
      transform: rotate(180deg);
    }
  }

  &__buttons {
    display: flex;
    justify-content: flex-start;
    column-gap: 20px;
  }
}
</style>
